// import { IResourceComponentsProps, GetListResponse } from "@refinedev/core";
// import { AntdInferencer } from "@refinedev/inferencer/antd";

// export const AutorPublicationsList: React.FC<IResourceComponentsProps<GetListResponse<{}>>> = () => {
//     return <AntdInferencer />;
// };


import React from "react";
import { IResourceComponentsProps, BaseRecord } from "@refinedev/core";
import Cw8List from "components/cw8/Cw8List";

export const AutorSectionPublicationsList: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "autorSectionPublication";
    return (
        <Cw8List
            resourceName = {resourceName}
        ></Cw8List>
    );
};